export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { id: 'bl', name: '耽美', slug: 'bl', icon: 'ri-user-heart-line' },
  { id: 'thriller', name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { id: 'horror', name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
  { id: 'historical', name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line' },
  { id: 'school', name: '校园', slug: 'school', icon: 'ri-book-open-line' },
  { id: 'workplace', name: '职场', slug: 'workplace', icon: 'ri-briefcase-line' },
];

export const comics = [
  {
    id: 1,
    title: '绝世医妃',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20female%20doctor%20in%20traditional%20hanbok%20with%20elegant%20updo%20hair%2C%20holding%20a%20medicine%20bottle%2C%20soft%20warm%20lighting%2C%20romantic%20drama%20atmosphere%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20delicate%20linework%20and%20subtle%20watercolor%20texture&width=600&height=800&seq=comic-01&orientation=portrait',
    description: '一场意外让现代女医生穿越到古代朝鲜，凭借精湛医术在宫廷中站稳脚跟。她不仅要面对复杂的宫廷斗争，还要在两位王子之间做出选择……',
    categories: ['romance', 'drama', 'historical'],
    rating: 4.8,
    views: 1250000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    tags: ['穿越', '医疗', '宫廷', '恋爱'],
    chapters: [
      { id: 1, title: '第1话 意外穿越', updatedAt: '2026-07-01' },
      { id: 2, title: '第2话 初入宫廷', updatedAt: '2026-07-05' },
      { id: 3, title: '第3话 医者仁心', updatedAt: '2026-07-10' },
      { id: 4, title: '第4话 危机四伏', updatedAt: '2026-07-15' },
      { id: 5, title: '第5话 王的恩宠', updatedAt: '2026-07-20' },
      { id: 6, title: '第6话 暗流涌动', updatedAt: '2026-07-25' },
      { id: 7, title: '第7话 真心告白', updatedAt: '2026-08-01' },
      { id: 8, title: '第8话 命运抉择', updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 2,
    title: '魔王大人的契约恋人',
    author: '李敏浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20fantasy%20illustration%20of%20a%20handsome%20demon%20lord%20with%20dark%20hair%20and%20red%20eyes%2C%20holding%20a%20girl%20protectively%2C%20magical%20glowing%20elements%2C%20dramatic%20lighting%2C%20dark%20gothic%20fantasy%20atmosphere%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20detailed%20costume%20design&width=600&height=800&seq=comic-02&orientation=portrait',
    description: '为了拯救重病的妹妹，她与传说中的魔王签订了契约。她以为自己只是献上灵魂的祭品，却没想到魔王对她产生了别样的兴趣……',
    categories: ['fantasy', 'romance', 'drama'],
    rating: 4.9,
    views: 2100000,
    status: 'ongoing',
    updatedAt: '2026-08-05',
    tags: ['魔王', '契约', '恋爱', '奇幻'],
    chapters: [
      { id: 1, title: '第1话 绝望的契约', updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 魔王的城堡', updatedAt: '2026-06-08' },
      { id: 3, title: '第3话 不可思议的温柔', updatedAt: '2026-06-15' },
      { id: 4, title: '第4话 逐渐靠近的心', updatedAt: '2026-06-22' },
      { id: 5, title: '第5话 危机的预感', updatedAt: '2026-07-01' },
      { id: 6, title: '第6话 真相浮现', updatedAt: '2026-07-10' },
      { id: 7, title: '第7话 誓言之吻', updatedAt: '2026-07-20' },
      { id: 8, title: '第8话 永恒的羁绊', updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 3,
    title: '剑与玫瑰',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20female%20warrior%20with%20long%20sword%20in%20medieval%20fantasy%20setting%2C%20flowing%20cape%2C%20determined%20expression%2C%20rose%20petals%20dancing%20in%20the%20air%2C%20dramatic%20cinematic%20lighting%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20dynamic%20action%20pose&width=600&height=800&seq=comic-03&orientation=portrait',
    description: '在剑与魔法的世界中，一位女骑士为了复仇踏上征途。她的剑可以斩断一切，但她的心却被一朵带刺的玫瑰所俘获。',
    categories: ['action', 'fantasy', 'romance'],
    rating: 4.7,
    views: 980000,
    status: 'completed',
    updatedAt: '2026-07-20',
    tags: ['剑士', '复仇', '恋爱', '冒险'],
    chapters: [
      { id: 1, title: '第1话 誓言之剑', updatedAt: '2026-01-10' },
      { id: 2, title: '第2话 踏上征途', updatedAt: '2026-01-20' },
      { id: 3, title: '第3话 命运的邂逅', updatedAt: '2026-02-01' },
      { id: 4, title: '第4话 并肩作战', updatedAt: '2026-02-15' },
      { id: 5, title: '第5话 真相与背叛', updatedAt: '2026-03-01' },
      { id: 6, title: '第6话 浴火重生', updatedAt: '2026-03-20' },
      { id: 7, title: '第7话 最终决战', updatedAt: '2026-04-10' },
      { id: 8, title: '第8话 剑与玫瑰（完）', updatedAt: '2026-05-01' },
    ],
  },
  {
    id: 4,
    title: '心跳加速的瞬间',
    author: '尹彩英',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20school%20romance%20illustration%20of%20a%20shy%20high%20school%20girl%20and%20a%20popular%20boy%20standing%20under%20cherry%20blossom%20tree%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%2C%20warm%20sunlight%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20gentle%20romantic%20mood&width=600&height=800&seq=comic-04&orientation=portrait',
    description: '平凡女高中生苏荷在一次意外中与校草产生了交集。从那以后，每次见到他，她的心跳都会不受控制地加速……',
    categories: ['romance', 'school', 'comedy'],
    rating: 4.6,
    views: 1580000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    tags: ['校园', '暗恋', '甜宠', '青春'],
    chapters: [
      { id: 1, title: '第1话 初遇', updatedAt: '2026-05-01' },
      { id: 2, title: '第2话 偶然的重逢', updatedAt: '2026-05-10' },
      { id: 3, title: '第3话 图书馆的秘密', updatedAt: '2026-05-20' },
      { id: 4, title: '第4话 心跳的声音', updatedAt: '2026-06-01' },
      { id: 5, title: '第5话 意外的约会', updatedAt: '2026-06-15' },
      { id: 6, title: '第6话 误会与和解', updatedAt: '2026-07-01' },
      { id: 7, title: '第7话 学园祭', updatedAt: '2026-07-20' },
      { id: 8, title: '第8话 告白前夜', updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 5,
    title: '暗影追踪',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%2C%20mysterious%20silhouette%20in%20background%2C%20neon%20reflections%20on%20wet%20ground%2C%20noir%20atmosphere%2C%20clean%20composition%2C%20manga%20art%20style%20with%20gritty%20urban%20feel&width=600&height=800&seq=comic-05&orientation=portrait',
    description: '一位警探在调查连环失踪案时，逐渐发现案件背后隐藏着一个庞大的犯罪网络。每一条线索都指向一个无法想象的真相……',
    categories: ['thriller', 'action', 'drama'],
    rating: 4.5,
    views: 720000,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    tags: ['悬疑', '犯罪', '侦探', '推理'],
    chapters: [
      { id: 1, title: '第1话 失踪', updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 第一个线索', updatedAt: '2026-06-12' },
      { id: 3, title: '第3话 目击者', updatedAt: '2026-06-24' },
      { id: 4, title: '第4话 地下世界', updatedAt: '2026-07-05' },
      { id: 5, title: '第5话 意外的同盟', updatedAt: '2026-07-18' },
      { id: 6, title: '第6话 步步逼近', updatedAt: '2026-08-03' },
    ],
  },
  {
    id: 6,
    title: '爱上你的谎言',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20BL%20romance%20illustration%20of%20two%20handsome%20men%20facing%20each%20other%20with%20intense%20eye%20contact%2C%20one%20in%20a%20suit%20and%20one%20in%20casual%20attire%2C%20soft%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20delicate%20facial%20expressions&width=600&height=800&seq=comic-06&orientation=portrait',
    description: '为了保住工作，他谎称自己已婚。当上司要求见他的妻子时，他不得不雇佣一位"假妻子"。然而，这位"妻子"竟是公司新来的男同事……',
    categories: ['bl', 'comedy', 'workplace'],
    rating: 4.8,
    views: 1890000,
    status: 'ongoing',
    updatedAt: '2026-08-05',
    tags: ['耽美', '职场', '伪装', '甜宠'],
    chapters: [
      { id: 1, title: '第1话 一个谎言', updatedAt: '2026-04-01' },
      { id: 2, title: '第2话 假妻子登场', updatedAt: '2026-04-15' },
      { id: 3, title: '第3话 同居生活', updatedAt: '2026-05-01' },
      { id: 4, title: '第4话 假戏真做', updatedAt: '2026-05-20' },
      { id: 5, title: '第5话 心动的信号', updatedAt: '2026-06-10' },
      { id: 6, title: '第6话 谎言即将揭穿', updatedAt: '2026-07-01' },
      { id: 7, title: '第7话 真心话', updatedAt: '2026-07-20' },
      { id: 8, title: '第8话 不再说谎', updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 7,
    title: '美食猎人',
    author: '安宰贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cooking%20fantasy%20illustration%20of%20a%20young%20chef%20holding%20a%20magical%20glowing%20dish%2C%20surrounded%20by%20floating%20ingredients%2C%20fantasy%20food%20elements%2C%20warm%20kitchen%20lighting%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20vibrant%20food%20colors&width=600&height=800&seq=comic-07&orientation=portrait',
    description: '在美食即是力量的世界中，一位少年厨师通过烹饪神奇的料理来击败魔兽、拯救村庄。每一道菜都是一次冒险！',
    categories: ['fantasy', 'comedy', 'action'],
    rating: 4.4,
    views: 650000,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    tags: ['美食', '冒险', '少年', '热血'],
    chapters: [
      { id: 1, title: '第1话 厨师的诞生', updatedAt: '2026-05-01' },
      { id: 2, title: '第2话 传说中的食材', updatedAt: '2026-05-18' },
      { id: 3, title: '第3话 魔兽讨伐', updatedAt: '2026-06-05' },
      { id: 4, title: '第4话 料理对决', updatedAt: '2026-06-22' },
      { id: 5, title: '第5话 龙肉料理', updatedAt: '2026-07-10' },
      { id: 6, title: '第6话 终极食谱', updatedAt: '2026-08-02' },
    ],
  },
  {
    id: 8,
    title: '午夜回廊',
    author: '金惠珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20horror%20illustration%20of%20a%20girl%20holding%20a%20candle%20in%20a%20dark%20corridor%20with%20mysterious%20shadows%2C%20eerie%20atmosphere%2C%20faint%20ghostly%20figure%20in%20distance%2C%20gothic%20elements%2C%20clean%20composition%2C%20manga%20art%20style%20with%20chilling%20mood%20and%20detailed%20shadow%20work&width=600&height=800&seq=comic-08&orientation=portrait',
    description: '搬进老宅的第一晚，她就在午夜时分听到了走廊尽头的脚步声。没有人住在那里——至少，没有活着的人……',
    categories: ['horror', 'thriller', 'drama'],
    rating: 4.3,
    views: 890000,
    status: 'completed',
    updatedAt: '2026-07-15',
    tags: ['恐怖', '灵异', '悬疑', '老宅'],
    chapters: [
      { id: 1, title: '第1话 搬家', updatedAt: '2026-03-01' },
      { id: 2, title: '第2话 脚步声', updatedAt: '2026-03-15' },
      { id: 3, title: '第3话 镜中人', updatedAt: '2026-04-01' },
      { id: 4, title: '第4话 地下室', updatedAt: '2026-04-20' },
      { id: 5, title: '第5话 怨灵', updatedAt: '2026-05-10' },
      { id: 6, title: '第6话 真相', updatedAt: '2026-06-01' },
      { id: 7, title: '第7话 永别（完）', updatedAt: '2026-06-30' },
    ],
  },
  {
    id: 9,
    title: '女王的棋局',
    author: '孙艺珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20historical%20drama%20illustration%20of%20a%20queen%20in%20elaborate%20royal%20hanbok%20sitting%20on%20a%20throne%2C%20holding%20a%20chess%20piece%2C%20palace%20interior%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20intricate%20textile%20details&width=600&height=800&seq=comic-09&orientation=portrait',
    description: '朝鲜王朝末期，一位被废黜的王妃通过权谋和智慧重新夺回自己的地位。每一步都是一场精心设计的棋局。',
    categories: ['historical', 'drama', 'romance'],
    rating: 4.7,
    views: 1350000,
    status: 'ongoing',
    updatedAt: '2026-08-05',
    tags: ['古风', '宫斗', '权谋', '女王'],
    chapters: [
      { id: 1, title: '第1话 废妃', updatedAt: '2026-04-10' },
      { id: 2, title: '第2话 蛰伏', updatedAt: '2026-04-25' },
      { id: 3, title: '第3话 布局', updatedAt: '2026-05-10' },
      { id: 4, title: '第4话 反击', updatedAt: '2026-05-30' },
      { id: 5, title: '第5话 博弈', updatedAt: '2026-06-20' },
      { id: 6, title: '第6话 将军', updatedAt: '2026-07-10' },
      { id: 7, title: '第7话 新秩序', updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 10,
    title: '社内恋爱禁止令',
    author: '崔多美',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20office%20romance%20illustration%20of%20a%20couple%20secretly%20holding%20hands%20behind%20their%20backs%20in%20modern%20office%20setting%2C%20playful%20atmosphere%2C%20warm%20lighting%20from%20window%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20charming%20character%20design&width=600&height=800&seq=comic-10&orientation=portrait',
    description: '公司明令禁止办公室恋情，但两位部门主管却在暗中发展着一段甜蜜的关系。他们能守住这个秘密吗？',
    categories: ['romance', 'workplace', 'comedy'],
    rating: 4.5,
    views: 780000,
    status: 'completed',
    updatedAt: '2026-06-30',
    tags: ['职场', '恋爱', '秘密', '甜宠'],
    chapters: [
      { id: 1, title: '第1话 敌对部门', updatedAt: '2026-01-05' },
      { id: 2, title: '第2话 意外的咖啡', updatedAt: '2026-01-20' },
      { id: 3, title: '第3话 加班之夜', updatedAt: '2026-02-10' },
      { id: 4, title: '第4话 公司团建', updatedAt: '2026-03-01' },
      { id: 5, title: '第5话 秘密暴露', updatedAt: '2026-03-25' },
      { id: 6, title: '第6话 幸福结局（完）', updatedAt: '2026-05-01' },
    ],
  },
  {
    id: 11,
    title: '灵能学院',
    author: '宋仲基',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20supernatural%20school%20illustration%20of%20students%20with%20glowing%20magical%20powers%20in%20a%20mystical%20academy%2C%20floating%20crystals%2C%20magical%20auras%2C%20fantasy%20school%20uniforms%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20dynamic%20energy%20effects&width=600&height=800&seq=comic-11&orientation=portrait',
    description: '平凡高中生一夜之间觉醒了灵能，被招入一所隐藏在都市中的神秘学院。在这里，他发现了自己的身世之谜和隐藏在学院深处的黑暗秘密。',
    categories: ['fantasy', 'action', 'school'],
    rating: 4.6,
    views: 1100000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    tags: ['异能', '学院', '冒险', '热血'],
    chapters: [
      { id: 1, title: '第1话 觉醒', updatedAt: '2026-03-01' },
      { id: 2, title: '第2话 入学考试', updatedAt: '2026-03-18' },
      { id: 3, title: '第3话 分班', updatedAt: '2026-04-05' },
      { id: 4, title: '第4话 第一次任务', updatedAt: '2026-04-25' },
      { id: 5, title: '第5话 地下密室', updatedAt: '2026-05-15' },
      { id: 6, title: '第6话 禁术', updatedAt: '2026-06-10' },
      { id: 7, title: '第7话 背叛者', updatedAt: '2026-07-05' },
      { id: 8, title: '第8话 最终试炼', updatedAt: '2026-08-04' },
    ],
  },
  {
    id: 12,
    title: '重生之逆天改命',
    author: '刘在石',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20reincarnation%20drama%20illustration%20of%20a%20determined%20man%20standing%20before%20two%20diverging%20paths%20representing%20past%20and%20future%2C%20dramatic%20golden%20hour%20lighting%2C%20symbolic%20clock%20imagery%2C%20clean%20composition%2C%20soft%20cream%20background%2C%20manga%20art%20style%20with%20emotional%20depth&width=600&height=800&seq=comic-12&orientation=portrait',
    description: '商界精英在一场车祸中丧生，却意外重生回到二十年前。带着前世的记忆和经验，他决心改变命运，走向完全不同的人生。',
    categories: ['drama', 'romance', 'workplace'],
    rating: 4.9,
    views: 2500000,
    status: 'ongoing',
    updatedAt: '2026-08-05',
    tags: ['重生', '经商', '逆袭', '爽文'],
    chapters: [
      { id: 1, title: '第1话 死亡与新生', updatedAt: '2026-02-01' },
      { id: 2, title: '第2话 回到1998', updatedAt: '2026-02-15' },
      { id: 3, title: '第3话 第一桶金', updatedAt: '2026-03-01' },
      { id: 4, title: '第4话 商海沉浮', updatedAt: '2026-03-20' },
      { id: 5, title: '第5话 昔日情缘', updatedAt: '2026-04-10' },
      { id: 6, title: '第6话 对手出现', updatedAt: '2026-05-01' },
      { id: 7, title: '第7话 金融危机', updatedAt: '2026-05-25' },
      { id: 8, title: '第8话 绝地反击', updatedAt: '2026-06-20' },
      { id: 9, title: '第9话 帝国崛起', updatedAt: '2026-07-15' },
      { id: 10, title: '第10话 命中注定', updatedAt: '2026-08-05' },
    ],
  },
];

export const banners = [
  {
    id: 1,
    comicId: 2,
    title: '魔王大人的契约恋人',
    subtitle: '年度最受欢迎奇幻恋爱韩漫',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20fantasy%20landscape%20with%20a%20demon%20lord%20castle%20silhouette%20at%20sunset%2C%20magical%20aurora%20in%20the%20sky%2C%20dramatic%20warm%20golden%20orange%20lighting%2C%20epic%20cinematic%20composition%2C%20clean%20gradient%20with%20soft%20cream%20tones%2C%20romantic%20fantasy%20atmosphere&width=1600&height=600&seq=banner-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 12,
    title: '重生之逆天改命',
    subtitle: '评分4.9！全网热议的逆袭神作',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20dramatic%20cityscape%20with%20towering%20skyscrapers%20at%20golden%20hour%2C%20man%20standing%20on%20rooftop%20looking%20over%20the%20city%2C%20warm%20amber%20lighting%2C%20cinematic%20widescreen%20composition%2C%20clean%20gradient%20with%20soft%20cream%20tones%2C%20dramatic%20anime%20atmosphere&width=1600&height=600&seq=banner-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 1,
    title: '绝世医妃',
    subtitle: '穿越宫廷，医术无双，浪漫权谋大作',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20traditional%20palace%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20spring%20sunlight%20filtering%20through%20petals%2C%20romantic%20historical%20atmosphere%2C%20cinematic%20widescreen%20composition%2C%20clean%20gradient%20with%20soft%20cream%20tones%2C%20elegant%20traditional%20aesthetic&width=1600&height=600&seq=banner-03&orientation=landscape',
  },
];

export const reviews = [
  { id: 1, name: '漫画迷小明', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20portrait%20of%20a%20young%20person%2C%20minimalist%20flat%20illustration%2C%20warm%20tones%2C%20soft%20cream%20background&width=100&height=100&seq=avatar-01&orientation=squarish', rating: 5, content: '汗汗漫画的韩漫资源真的太全了！找了好久的冷门作品这里都有，更新速度也超快，已经成为我的每日必刷网站了。', date: '2026-08-01' },
  { id: 2, name: '追漫少女', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20portrait%20of%20a%20girl%2C%20minimalist%20flat%20illustration%2C%20warm%20tones%2C%20soft%20cream%20background&width=100&height=100&seq=avatar-02&orientation=squarish', rating: 5, content: '页面很清爽，没有乱七八糟的广告，阅读体验超棒！分类也很细致，找漫画特别方便。强烈推荐！', date: '2026-07-28' },
  { id: 3, name: '资深漫友老张', avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime%20style%20portrait%20of%20an%20adult%20man%2C%20minimalist%20flat%20illustration%2C%20warm%20tones%2C%20soft%20cream%20background&width=100&height=100&seq=avatar-03&orientation=squarish', rating: 5, content: '看了十几年漫画，汗汗漫画是我用过最舒服的韩漫平台。收录全面、更新及时，最重要的是完全免费！', date: '2026-07-25' },
];